import gql from "graphql-tag";

export const offeredFragment = gql`
  fragment OfferedFragment on Offered {
    id
    amountNet
    date
    comment
    project {
      id
      name
    }
    invoice {
      id
      invoiceStatus: status
    }
    creditNoteFor {
      id
      invoiceStatus: status
    }
    validated
  }
`;
